import React, { createContext, useContext, useRef, useState } from 'react'
import HelperString from 'utils/helper-string'
import SplashView from 'components/molecules/SplashView'
import { useDispatch, useSelector } from 'react-redux'
import selectEmployeeLanguage from 'services/redux/data/selectors/selectEmployeeLanguage'
import LoginCheckError from 'components/molecules/LoginCheckError'
import UserService from 'services/user'
import { resetData } from 'services/redux/data/actions'
import { resetManagement } from 'services/redux/management/actions'
import { resetAuthentication } from 'services/redux/authentication/actions'
import { resetCart } from 'services/redux/cart/actions'
import { appRestart } from 'utils/helper-restart'

export const SplashProviderContext = createContext( null );

export const useSplash  = () => {
	return useContext( SplashProviderContext );
}

const SplashProvider = ({ children }) => {
	
	const dispatch = useDispatch()
	const _employeeLanguage = useSelector( selectEmployeeLanguage )
	
	const splashRef = useRef()
	
	const [ splashVisible, setSplashVisible ] = useState( true )
	const [ isLoggingIn, setIsLoggingIn ] = useState( false );
	const [ error, setError ] = useState( false )
	
	const logout = () => {
		UserService.logout({
			resetData: () => {
				return dispatch(resetData());
			},
			resetManagement: () => {
				return dispatch(resetManagement());
			},
			resetAuthentication: () => {
				return dispatch(resetAuthentication());
			},
			resetCart: () => {
				return dispatch(resetCart());
			},
		});
	}
	
	const setProgressBarPercentage = ( value ) => {
		splashRef?.current?.setPercentage( value )
	}
	
	const hideSplash = () => {
		setSplashVisible( false )
	}
	
	const fadeOutSplash = () => {
		if( splashVisible ) {
			splashRef?.current?.fadeOut( hideSplash );
		}
	}
	
	const setLoadingError = ( value ) => {
		setError( value )
	}
	
	return (
		<SplashProviderContext.Provider
			value={{
				setIsLoggingIn: setIsLoggingIn,
				splashVisible: splashVisible,
				logout: logout,
				fadeOutSplash: fadeOutSplash,
				setLoadingError: setLoadingError,
				setProgressBarPercentage: setProgressBarPercentage
			}}>
			
			{ (error === false && splashVisible) && (
				<SplashView
					ref={ splashRef }
					isLoggingIn={ isLoggingIn }
					key={ HelperString.hash("splashview", _employeeLanguage?.code ) }
				/>
			)}
			
			{ (error !== false) && (
				<LoginCheckError
					key={ HelperString.hash("logincheck", _employeeLanguage?.code ) }
					action={ appRestart.bind( this ) }
					logoutCallback={ logout }
				/>
			)}
			
			{ error === false && children }
		</SplashProviderContext.Provider>
	)
}

export default SplashProvider
